import xhr from 'xhr'
import filtersPopin from './filtersPopin'
import carList from './carList'
import api from './api'
import carListSlider from './carListSlider'
import noUiSlider from 'nouislider'
import wNumnb from 'wnumb'
import trackingFirstInteraction from "./trackingFirstInteraction";
import TrackingFirstInteraction from "./trackingFirstInteraction";
import MiniMessagePoster from "./miniMessagePoster";

class filtersAjaxRequest {
  constructor() {
    this.filtersButtons = document.querySelectorAll('.filter-input')
    this.currentPage = document.querySelector('.page__gamme')
    this.campaignSlug = this.currentPage.getAttribute('data-campaign')
    this.campaignFormSlug = this.currentPage.getAttribute('data-form')
    this.priceSlider = document.querySelector('#price-slider')
    this.rentSlider = document.querySelector('#rent-slider')
    this.isPreviewPage =
      this.currentPage.getAttribute('data-preview') === '0'
        ? ''
        : '/admin/preview'
    this.formInRequest = this.currentPage.getAttribute('data-form-in-request')
    this.lang = document.documentElement.lang
    this.enableFilterButton()
    this.currentCheckedInput
    this.initializePriceRangeSlider()
    this.initializeResetFiltersButtons()
    /*this.resetFilterOnClick()*/
    this.loadMore()
    this.filtersButtons.forEach(btn => {
      btn.addEventListener('click', ()=> {
        btn.classList.add('clicked')
      })
    })
  }

  getRentPriceRange() {
    return [25, 50, 100]
  }
  getTotalPriceRange() {
    return [1000, 2000, 5000]
  }

  getRangeSlider(min, max, potentialSteps) {
    var range = max - min,
        bestStep = 0;

    var range_all_sliders = {
      'min': [ min, potentialSteps[0] ],
      'max': [ max ]
    }

    potentialSteps.forEach(function (step, index) {
      //console.log(step,  range/step)
      if(range / step > 100) {
        bestStep = index + 1;
        return;
      }
    })
    if (range > potentialSteps[0] * 40) {
      var firstStep = Math.ceil(min / potentialSteps[bestStep]) * potentialSteps[bestStep],
          sixtyStep = potentialSteps[parseInt(bestStep + 1)],
          eightyStep = potentialSteps[parseInt(bestStep + 2)] ? potentialSteps[parseInt(bestStep + 2)] : potentialSteps[potentialSteps.length - 1];
      var range_all_sliders = {
        'min': [ min, parseInt(firstStep - min) ],
        '1%': [ firstStep, potentialSteps[bestStep] ],
        '60%': [ Math.ceil((parseInt(range * 50 / 100)) / sixtyStep) * sixtyStep, sixtyStep ], // 60% of selector = 50% of price to favorize low prices
        '80%': [ Math.ceil((parseInt(range * 60 / 100)) / eightyStep) * eightyStep, eightyStep],
        'max': [ max ]
      }
      if(firstStep === min) {
        range_all_sliders['min'] = [ min, potentialSteps[bestStep] ];
        delete range_all_sliders["1%"]
      }
      if (sixtyStep === eightyStep) {
        delete range_all_sliders["60%"]
      }
    }

    console.log('best step ' + bestStep + '(' + potentialSteps[bestStep] + ')', potentialSteps, potentialSteps[parseInt(bestStep + 1)], range_all_sliders)
    return range_all_sliders
  }

  initializePriceRangeSlider() {

      if(this.priceSlider) {
        var sliderRange = this.getRangeSlider(parseInt(this.priceSlider.dataset.min), parseInt(this.priceSlider.dataset.max), this.getTotalPriceRange())
        noUiSlider
            .create(this.priceSlider, {
              start: [parseFloat(this.priceSlider.dataset.min), parseFloat(this.priceSlider.dataset.max)],
              tooltips: [wNumnb({decimals: 0, thousand: ' ', suffix: ' €'}), wNumnb({decimals: 0, thousand: ' ', suffix: ' €'})],
              connect: true,
              //step: 2000,
              /*margin: (this.priceSlider.dataset.max - this.priceSlider.dataset.min) * 0.2,
              range: {
                'min': parseFloat(this.priceSlider.dataset.min),
                'max': parseFloat(this.priceSlider.dataset.max)
              },*/
              range: sliderRange
            })
            .on('change', () => {
              document.body.classList.add('ajax-loading-cars')
              this.rentSlider.noUiSlider.reset()
              let filterList = this.generateFilterList()
              this.getFilteredList(filterList)
            })

        this.mergeTooltips(this.priceSlider, 30, ' - ', wNumnb({decimals: 0, thousand: ' ', suffix: ' €'}));
      }
      if(this.rentSlider) {
        var sliderRange = this.getRangeSlider(parseInt(this.rentSlider.dataset.min), parseInt(this.rentSlider.dataset.max), this.getRentPriceRange())
        noUiSlider
            .create(this.rentSlider, {
              start: [parseFloat(this.rentSlider.dataset.min), parseFloat(this.rentSlider.dataset.max)],
              tooltips: [wNumnb({decimals: 0, thousand: ' ', suffix: ' €'}), wNumnb({decimals: 0, thousand: ' ', suffix: ' €'})],
              connect: true,
              //step: 25,
              /*margin: (this.rentSlider.dataset.max - this.rentSlider.dataset.min) * 0.2, // min range between min/max needs to be max 20% of min/max interval
              range: {
                'min': parseFloat(this.rentSlider.dataset.min),
                'max': parseFloat(this.rentSlider.dataset.max)
              },*/
              range: sliderRange
            })
            .on('change', () => {
              document.body.classList.add('ajax-loading-cars')
              this.priceSlider.noUiSlider.reset()
              let filterList = this.generateFilterList()
              this.getFilteredList(filterList)
          })
        this.mergeTooltips(this.rentSlider, 20, ' - ', wNumnb({decimals: 0, thousand: ' ', suffix: ' €'}));
      }
  }

  initializeResetFiltersButtons() {
    document.querySelectorAll('.btn-reset-filter').forEach(resetFiltersBtn => {
      resetFiltersBtn.addEventListener('click', () => {

        document.body.classList.add('ajax-loading-cars')

        document.querySelectorAll('.filter-input:checked').forEach(filter => {
          filter.checked = false
        })
        if(this.priceSlider) {
          this.priceSlider.noUiSlider.set([this.priceSlider.dataset.min, this.priceSlider.dataset.max])
        }
        if (this.rentSlider) {
          this.rentSlider.noUiSlider.set([this.rentSlider.dataset.min, this.rentSlider.dataset.max])
        }

        setTimeout(() => {
          let filterList = this.generateFilterList()
          this.getFilteredList(filterList)
        }, 200)

      })
    })
  }

  getOrigin() {
    const currentLocation = window.location.href
    const isOrigin = currentLocation.indexOf('?ORIGINE=')
    const value =
      isOrigin >= 0
        ? `?ORIGINE=${currentLocation.substr(
          currentLocation.indexOf('=') + 1,
          currentLocation.length
        )}`
        : ''
    return value
  }

  findAncestorAttribute(el, attr) {
    while ((el = el.parentElement) && !el.getAttribute(attr));
    return el
  }

  findAncestorClass(el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el
  }

  getFilterCatLength(elem) {
    return this.findAncestorClass(
      elem,
      'car-filters'
    ).querySelectorAll('.filter-input:checked').length
  }

  setFilterCount(elem, count) {
    const filterCountNode = this.findAncestorClass(
      elem,
      'car-filters__item'
    ).querySelector('.filter-count')
    count !== 0
      ? (filterCountNode.innerText = count)
      : (filterCountNode.innerText = '')
  }

  enableFilterButton() {
    // on button click, close filters
    const buttons = document.querySelectorAll('.filter-models')
    buttons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault()
        document.body.classList.remove('open')
        if (window.matchMedia('(min-width: 1024px)').matches) {
          const tab = this.findAncestorClass(
            e.currentTarget,
            'car-filters__item'
          )
          tab.classList.remove('open')
        } else {
          const tab = this.findAncestorClass(
            e.currentTarget,
            'car-filters__list'
          )
          tab.classList.remove('open')
        }
      })
    })
  }

  loadFilteredContent() {
    // Get all filters
    const filters = document.querySelectorAll('.filter-input')

    filters.forEach(elem => {
      // when clicking on a filter
      elem.addEventListener('change', () => {
        document.body.classList.add('ajax-loading-cars')
        this.currentCheckedInput = elem
        document.querySelectorAll('[id="'+ elem.id +'"]').forEach(filter => {
          filter.checked = elem.checked
        })

        setTimeout(() => {
          let filterList = this.generateFilterList()
          this.getFilteredList(filterList)
        }, 200)

      })
    })
  }

  generateFilterList() {

    const filterList = {}

    // create an array of filters

    // Get all checked inputs
    const checkedInputs = document.querySelectorAll('.filter-input:checked')
    // Ensure it runs once
    // console.log('checkedInputs')
    // For each checked input

    let clickedCategory
    if (document.querySelector('.clicked')) {
      clickedCategory = this.findAncestorAttribute(
        document.querySelector('.clicked'),
        'data-category'
      ).getAttribute('data-category')
    } else {
      clickedCategory = 'not-category'
    }

    checkedInputs.forEach(el => {

      if (el.checked) {
        // Checked returned inputs
        // console.log(el)
        // Get filter & category attributes
        const categoryAttribute = this.findAncestorAttribute(
          el,
          'data-category'
        ).getAttribute('data-category')
        const elemAttribute = el.getAttribute('data-filter')

        // if category doesnt exists, create it
        if (!filterList[categoryAttribute]) {
          filterList[categoryAttribute] = []
        }
        // push filter on category
        if (!(clickedCategory === 'category' && categoryAttribute === 'series') && !(clickedCategory === 'series' && categoryAttribute === 'category')) {
          filterList[categoryAttribute].push(elemAttribute)
        } else {
          el.checked = false
        }
      }
    })

    if (document.querySelector('.clicked')) {
      document.querySelector('.clicked').classList.remove('clicked')
    }

    // generate pricing filter array
    let uiPrice = document.getElementById('price-slider'),
        uiRent = document.getElementById('rent-slider')

    if(uiPrice) {
      filterList['price'] = {}
      let priceRange = uiPrice.noUiSlider.get()
      // if user has change selector range
      if (parseInt(uiPrice.dataset.min) !== parseInt(priceRange[0]) || parseInt(uiPrice.dataset.max) !== parseInt(priceRange[1])) {
        if(parseInt(priceRange[0]) && parseInt(priceRange[1])) {
          filterList['price']['min'] = priceRange[0]
          filterList['price']['max'] = priceRange[1]
        }
      }
    }
    if(uiRent) {
      filterList['rent'] = {}
      let rentRange = uiRent.noUiSlider.get()
      // if user has change selector range
      if (parseInt(uiRent.dataset.min) !== parseInt(rentRange[0]) || parseInt(uiRent.dataset.max) !== parseInt(rentRange[1])) {
        if(parseInt(rentRange[0]) && parseInt(rentRange[1])) {
          filterList['rent']['min'] = rentRange[0]
          filterList['rent']['max'] = rentRange[1]
        }
      }
    }
    return filterList
  }

  addFilter(input, filterList) {
    // if we check input
    if (input.checked) {
      // filter is created
      const label = document.querySelector(`label[for="${input.id}"]`)
        .innerText
      const activeFiltersList = document.querySelector('.car-filters__active ul')

      // Add filter to filter list
      let listElem = document.createElement('li')
      listElem.setAttribute('data-filter', input.id)
      listElem.innerHTML = `
        <span>${label}</span>
        <span class="close"></span>
      `
      activeFiltersList.appendChild(listElem)

      // When cross is clicked, filter is removed
      const newFilter = document.querySelector(`li[data-filter="${input.id}"]`)

      newFilter.querySelector('.close').addEventListener('click', _ => {
        this.removeFilter(input, newFilter)
      })
    } else {
      // filter is removed
      document.querySelector(`li[data-filter="${input.id}"]`).remove()
    }
  }

  removeFilter(input, filter) {
    document.getElementById(filter.getAttribute('data-filter')).checked = false
    filter.remove()

    this.setFilterCount(input, this.getFilterCatLength(input))

    // create an array of filters
    const filterList = {}

    // Get all checked inputs
    const checkedInputs = document.querySelectorAll('.filter-input:checked')

    // For each checked input
    checkedInputs.forEach(el => {
      // Get filter & category attributes
      const categoryAttribute = this.findAncestorAttribute(
        el,
        'data-category'
      ).getAttribute('data-category')
      const elemAttribute = el.getAttribute('name')

      // if category doesnt exists, create it
      if (!filterList[categoryAttribute]) {
        filterList[categoryAttribute] = []
      }

      // push filter on category
      filterList[categoryAttribute].push(elemAttribute)
    })

    this.getFilteredList(filterList)
  }

  getFilteredList(content) {
    xhr(
      {
        method: 'POST',
        body: JSON.stringify({
          filters: content,
         'campaign': this.currentPage.getAttribute('data-campaign-id')
        }),
        uri: `${api().bmw}/${this.campaignSlug}/${ this.campaignFormSlug }/cars/filter`+ window.location.search,
        headers: {
            'Content-Type': 'application/json'
        },
        'Access-Control-Allow-Origin': `${api().bmw}/${this.campaignSlug}/${
        this.campaignFormSlug
        }/cars/filter`
      },
      (err, resp, body) => {
        // Display filtered list
        try {
          const result = JSON.parse(body)
          if (result.message === 'ok') {
            //this.displayCarList(result)
            this.displayDefaultList(result)
            // this.loadMore()
          } else {
            this.displayEmptyMessage(result)
          }

          document.body.classList.remove('ajax-loading-cars')
          carList().toggleCarCards()
        } catch (e) {
          document.body.classList.remove('ajax-loading-cars')
        }
      }
    )
    // action can be a firstInteraction, trigger event
    const trackingFirstInteractionItem = new TrackingFirstInteraction()
    trackingFirstInteractionItem.triggerFirstInteraction()
  }

  checkIfSelected() {
    return document.querySelectorAll('.filter-input:checked').length
  }

  displayFilter(filter) {
    filter.parentNode.style.opacity = '1'
    filter.parentNode.style.pointerEvents = 'initial'
  }

  hideFilter(filter) {
    filter.parentNode.style.opacity = '0.5'
    filter.parentNode.style.pointerEvents = 'none'
  }

  displayEmptyMessage(result) {
    document.querySelector('.total-car > span:first-child').style.opacity = '0'
    document.querySelector('.car-lists').innerHTML = `<div class="empty-result">
                                                                 <p>${result.message}</p>
                                                               </div>`
  }

  displayDefaultList(result) {
    let link = ''
    let params = `${window.location.search.slice(1)}`
    let vo = ''
    if (document.querySelector('.main-values').getAttribute('data-vo-breadcrumb') == '1') {
      vo = '&vo=1'
    }
    const series = result.result
    let carsFoundInRequest = 0,
        injectable = '<ol><li><ul>'
    for (const key in series) {
      const vehicules = series[key]['vehicules']
      for (let i = 0; i < vehicules.length; i++) {
        injectable += vehicules[i].render
        carsFoundInRequest++
      }

      let btnValidate = document.querySelector('.btn-validate')
      btnValidate.innerHTML = btnValidate.innerHTML.replace(/\b([0-9]|[1-9][0-9]|100)\b/, vehicules.length)
    }
    injectable += '</li> </ul>'
    if (carsFoundInRequest > 15) {
      let showMorePlaceHolder = this.getLoadMorePlaceHolder();
      injectable += `<button class="show-more">${this.getLoadMoreLabel(carsFoundInRequest - 15)}</button>`
    }
    injectable += '</ol>'
    document.querySelector('.car-lists').innerHTML = injectable

    if (carsFoundInRequest < 15) {
      document.getElementById('first-result').innerHTML = carsFoundInRequest.toString()
    } else {
      document.getElementById('first-result').innerHTML = '15'
      document.querySelectorAll('.car-card:nth-child(n + 16)').forEach(el => {
        el.style.display = 'none'
        el.style.maxHeight = '0'
      })
    }
    document.getElementById('last-result').innerHTML = carsFoundInRequest.toString()
    document.getElementById('total-result').innerHTML = carsFoundInRequest.toString()

    carListSlider()
    this.loadMore()

    if (result.filters.price) {
      if (document.getElementById('price-slider')) {
        var initialMinPrice = parseInt(document.getElementById('price-slider').dataset.min),
            initialMaxPrice = parseInt(document.getElementById('price-slider').dataset.max),
            updatePriceRange = false;
        if (initialMinPrice > parseInt(result.filters.price['min']) || initialMaxPrice < parseInt(result.filters.price['max'])) {

          if (parseInt(result.filters.price['min']) && initialMinPrice > parseInt(result.filters.price['min'])) {
            document.getElementById('price-slider').dataset.min = parseInt(result.filters.price['min']);
            updatePriceRange = true
          }
          if (parseInt(result.filters.price['max']) && initialMaxPrice < parseInt(result.filters.price['max'])) {
            document.getElementById('price-slider').dataset.max = parseInt(result.filters.price['max']);
            updatePriceRange = true
          }
          if (updatePriceRange) {
            // actual price slider ranges can't handle new filters prices, update slider ranges
            let sliderRange = this.getRangeSlider(parseInt(result.filters.price['min']), parseInt(result.filters.price['max']), this.getTotalPriceRange())
            document.getElementById('price-slider').noUiSlider.updateOptions( {
              range: sliderRange
            })
            var minRange = initialMinPrice > parseInt(sliderRange['min']['0']) ? parseInt(sliderRange['min']['0']) : initialMinPrice
            var maxRange = initialMaxPrice < parseInt(sliderRange['max']['0']) ? parseInt(sliderRange['max']['0']) : initialMaxPrice
            document.getElementById('price-slider').noUiSlider.set([minRange, maxRange])
          }
        }
      }
    }

  if (result.filters.rent) {
      if (document.getElementById('rent-slider')) {
        var initialMinPrice = parseInt(document.getElementById('rent-slider').dataset.min),
            initialMaxPrice = parseInt(document.getElementById('rent-slider').dataset.max),
            updateRentRange = false;
        if (initialMinPrice > parseInt(result.filters.rent['min']) || initialMaxPrice < parseInt(result.filters.rent['max'])) {

          if (parseInt(result.filters.rent['min']) && initialMinPrice > parseInt(result.filters.rent['min'])) {
            document.getElementById('rent-slider').dataset.min = parseInt(result.filters.rent['min']);
            updateRentRange = true
          }
          if (parseInt(result.filters.rent['max']) && initialMaxPrice < parseInt(result.filters.rent['max'])) {
            document.getElementById('rent-slider').dataset.max = parseInt(result.filters.rent['max']);
            updateRentRange = true
          }
          if (updateRentRange) {
            // actual rent slider ranges can't handle new filters prices, update slider ranges
            let sliderRange = this.getRangeSlider(parseInt(result.filters.rent['min']), parseInt(result.filters.rent['max']), this.getTotalPriceRange())
            document.getElementById('rent-slider').noUiSlider.updateOptions( {
              range: sliderRange
            })
            var minRentRange = initialMinPrice > parseInt(sliderRange['min']['0']) ? parseInt(sliderRange['min']['0']) : initialMinPrice
            var maxRentRange = initialMaxPrice < parseInt(sliderRange['max']['0']) ? parseInt(sliderRange['max']['0']) : initialMaxPrice
            document.getElementById('rent-slider').noUiSlider.set([minRentRange, maxRentRange])
          }
        }
      }
    }
    document.querySelector('.total-car > span:first-child').style.opacity = '1'
    MiniMessagePoster.triggerResizeParent()
  }

  /*resetFilterOnClick() {
    let btnResetAllFilter = document.querySelector('.btn-reset-filter'),
        checkedInputs = document.querySelectorAll('.filter-input:checked')

    btnResetAllFilter.addEventListener('click', e => {
      checkedInputs.forEach(el => {
        el.checked = false
      })
    })
  }*/

  show(elem) {
    elem.style.display= 'block'
  }

  hide(elem) {
    elem.style.display= 'none'
  }

  getLoadMorePlaceHolder() {
    let placeholder = 'Afficher tout ( %nbToShow% véhicules )';
    let mainValues = document.querySelector('.main-values');
    if ('morePlaceholder' in mainValues.dataset) {
      placeholder = mainValues.dataset.morePlaceholder;
    }
    return placeholder;
  }

  getLoadMoreLabel(nb) {
    return this.getLoadMorePlaceHolder().replace('%nbToShow%', nb);
  }

  loadMore() {
    let carCards = document.querySelectorAll('.car-card'),
        showMore = document.querySelector('.show-more'),
        showMorePlaceHolder = this.getLoadMorePlaceHolder(),
        nbCards = carCards.length,
        seeFirstFifteen = Array.from(carCards).slice(0, 15)

    if (showMore && nbCards < 15) {
      this.hide(showMore)
    }

    carCards.forEach( carCard => {
      this.hide(carCard)

      let nbToShow = ((nbCards - 15) > 0) ? nbCards - 15 : nbCards
      if (showMore) {
        showMore.innerHTML = this.getLoadMoreLabel(nbToShow);
      }

      if (nbToShow < 15) {
        document.getElementById('first-result').innerHTML = nbToShow.toString()
      } else {
        document.getElementById('first-result').innerHTML = '15'
      }
      document.getElementById('last-result').innerHTML = nbCards.toString()
      document.getElementById('total-result').innerHTML = nbCards.toString()

      if (showMore) {
        showMore.addEventListener('click', e => {
          if (carCard.style.display === 'none') {
            carListSlider(carCard.querySelectorAll('.car-slider'));
            this.show(carCard)
            showMore.innerHTML = 'Afficher moins'
            document.getElementById('first-result').innerHTML = nbCards.toString()
          } else if (carCard.style.display === 'block') {
            document.getElementById('first-result').innerHTML = '15'
            this.hide(carCard)
            seeFirstFifteen.forEach( e => {
              this.show(e)
            })
            showMore.innerHTML = this.getLoadMoreLabel(nbToShow);
          }
        })
      }
    })

    seeFirstFifteen.forEach( e => {
      this.show(e)
    })

  }

  mergeTooltips(slider, threshold, separator, wNumbFormat) {

    var textIsRtl = getComputedStyle(slider).direction === 'rtl';
    var isRtl = slider.noUiSlider.options.direction === 'rtl';
    var isVertical = slider.noUiSlider.options.orientation === 'vertical';
    var tooltips = slider.noUiSlider.getTooltips();
    var origins = slider.noUiSlider.getOrigins();

    // Move tooltips into the origin element. The default stylesheet handles this.
    tooltips.forEach(function (tooltip, index) {
      if (tooltip) {
        origins[index].appendChild(tooltip);
      }
    });

    slider.noUiSlider.on('update', function (values, handle, unencoded, tap, positions) {

      var pools = [[]];
      var poolPositions = [[]];
      var poolValues = [[]];
      var atPool = 0;

      // Assign the first tooltip to the first pool, if the tooltip is configured
      if (tooltips[0]) {
        pools[0][0] = 0;
        poolPositions[0][0] = positions[0];
        poolValues[0][0] = values[0];
      }

      for (var i = 1; i < positions.length; i++) {
        if (!tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
          atPool++;
          pools[atPool] = [];
          poolValues[atPool] = [];
          poolPositions[atPool] = [];
        }

        if (tooltips[i]) {
          pools[atPool].push(i);
          poolValues[atPool].push(values[i]);
          poolPositions[atPool].push(positions[i]);
        }
      }

      pools.forEach(function (pool, poolIndex) {
        var handlesInPool = pool.length;

        for (var j = 0; j < handlesInPool; j++) {
          var handleNumber = pool[j];

          if (j === handlesInPool - 1) {
            var offset = 0;

            poolPositions[poolIndex].forEach(function (value) {
              offset += 1000 - value;
            });

            var direction = isVertical ? 'bottom' : 'right';
            var last = isRtl ? 0 : handlesInPool - 1;
            var lastOffset = 1000 - poolPositions[poolIndex][last];
            offset = (textIsRtl && !isVertical ? 100 : 0) + (offset / handlesInPool) - lastOffset;
            offset = (offset > 1 && offset < 13) ? 13 : offset // don't go out of the sidebar

            // Center this tooltip over the affected handles
            var formattedValues = poolValues[poolIndex].map(function (e) {
              e = wNumbFormat.to(parseInt(e))
              return e;
            });
            tooltips[handleNumber].innerHTML = formattedValues.join(separator);
            tooltips[handleNumber].style.display = 'block';
            tooltips[handleNumber].style[direction] = offset + '%';
          } else {
            // Hide this tooltip
            tooltips[handleNumber].style.display = 'none';
          }
        }
      });
    });
  }

}

export default filtersAjaxRequest
